<script setup lang="ts">
import type { FieldDefinition } from "~/models/Automation";

const modelValue = defineModel<string>("modelValue", { required: true });
const props = defineProps<{
    inheritable?: boolean;
    fields?: FieldDefinition[];
}>();
const builder = useMailStore();

const colors = computed(() => {
    const colors = (props.fields ?? builder.builderFields)
        .filter((field) => field.sub_type === "color")
        .map((field) => ({
            label: field.label,
            value: makeVariable(field.key),
            default_value: field.default_value,
        }));

    if (
        modelValue.value &&
        !colors.find((color) => color.value === modelValue.value)
    ) {
        colors.unshift({
            label: modelValue.value,
            value: modelValue.value,
            default_value: modelValue.value,
        });
    }

    if (props.inheritable) {
        colors.unshift({
            label: 'Inherit',
            value: 'inherit',
            default_value: 'inherit'
        })
    }

    return colors;
});

const color = computed({
    get: () => colors.value.find((color) => color.value === modelValue.value),
    set: (color) => (modelValue.value = color.value),
});
</script>

<template>
    <HdColorPickerMenu :options="colors" v-model:pure-color="color" format="hex8" size="lg" />
</template>
